angular.module('unica_event.event_services', []);